import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "../../_shark_models/Permission";

class PermissionManager extends Controller {
	constructor () {
		super("permissionManager");
	}


	
	getList () {
		const rd = NousCore.api.createRequest();

		NousCore.api.send("permission/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const permissionList = Shark.getInstanceList("Permission", data.items);

						permissionList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						})

						Shark.set({permissionList});

						return {
							data: "",
							status: "ok"
						}
					case 404:
						return {
							data: "",
							status: "ko"
						}
				}
			}
		});
	}
}

const permissionManager = new PermissionManager();

Shark.registerController(permissionManager);

export { permissionManager };
